// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__h6G2y","list":"styles_list__52rAr"};